<template>
	<SelectInline
		v-model="geo"
		:nothing-allowed="{
			enabled: false,
			nextLevelText: 'Alle Regionen/Bezirke möglich'
		}"
		:fan-config="{
			nothingAllowed: {
				textPerLevel: {
					1: 'Alle Regionen/Bezirke möglich'
				}
			},
			groupByLetter: {
				enabled: true,
				condition: {
					characteristicHasNotLabel: 'Wien'
				}
			},
			characteristicMetaProperty: 'geo',
			withKeyword: true,
			searchConfig: {
				type: searchTypeStartsWith
			},
			showMultipleHint: true,
			titleFormats: {
				level: {
					1: '%title%: in welchen Regionen/Bezirken?'
				}
			},
			maxLevel: 1
		}"
		:characteristic-type="meta.geoType"
		:characteristic-items="geoItems"
		initial-show-all
		show-multiple-hint
		label-type="application"
		@input="emitChangeEvent"
	/>
</template>

<script>
import {SEARCH_TYPE__STARTS_WITH} from "@/helper/characteristic/edit/SearchType";
import {onlyCountries} from "@/helper/characteristic/geo/Filter";
import {COUNTRY__AUSTRIA} from "@/helper/characteristic/geo/Geo";
import SelectInline from "@/vue/characteristic/SelectInline";
import {mapState} from "vuex";

export default {

	components: {
		SelectInline,
	},

	props: {
		value: {
			type: Array,
			required: false
		},
	},

	data ()
	{
		return {
			geo: this.value
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		searchTypeStartsWith ()
		{
			return SEARCH_TYPE__STARTS_WITH;
		},
		geoItems ()
		{
			return _.first(
				onlyCountries(this.meta.geo, COUNTRY__AUSTRIA)
			).children;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			// lone item is parent, which is not allowed here
			if (this.geo && this.geo.length === 1 && _.first(this.geo).item.naturalId === COUNTRY__AUSTRIA)
			{
				this.$emit('input', undefined);

				return;
			}

			this.$emit('input', this.geo);
		}
	}
}
</script>
